<script setup>
import { defineProps, reactive, ref, watch, onMounted } from 'vue';
import VueApexCharts from "vue3-apexcharts";

const chartLabelColor = '#fff';
const chartBarColor = '#4CAF50';
const chartExpectedAmountColor = '#775DD0';

const props = defineProps({
    data: {
        type: Array,
        required: true,
    },
    chartTitle: {
        type: String,
        default: null,
    },
    xAxisTitle: {
        type: String,
        default: null,
    },
    yAxisTitle: {
        type: String,
        default: null,
    },
    targetAmount: {
        type: Number,
        default: 0,
    }
});

let chartOptions = ref({
    chart: {
        type: "bar",
        stacked: false,
        foreColor: '#898989',
        zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
        },
        toolbar: {
            autoSelected: 'zoom',
            tools: {
                download: false
            }
        }
    },
    colors: [chartBarColor],
    stroke: {
        width: 1,
    },
    dataLabels: {
        enabled: false,
    },
    title: {
        text: props.chartTitle || '',
        align: 'center',
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: chartLabelColor
        },
    },
    grid: {
        enabled: false,
        yaxis: {
            lines: {
                show: false
            }
        },
        xaxis: {
            lines: {
                show: false
            }
        }
    },
    // xaxis: {
    //     axisBorder: {
    //         color: chartLabelColor,
    //     },
    //     title: {
    //         text: props.xAxisTitle || '',
    //         style: {
    //             color: chartLabelColor
    //         }
    //     },
    //     labels: {
    //         show: false
    //     }
    // },
    // yaxis: {
    //     min: 0,
    //     axisBorder: {
    //         color: chartLabelColor,
    //     },
    //     title: {
    //         text: props.yAxisTitle || '',
    //         style: {
    //             color: chartLabelColor,
    //         },
    //     },
    //     tooltip: {
    //         enabled: true,
    //     },
    // },
    fill: {
        opacity: 1,
        type: 'solid',
    },
    yaxis: {
        title: 'Reps'
    },
    xaxis: {
        type: 'datetime',
        title: 'Days',
    },
    tooltip: {
        shared: false,
        theme: "dark",
        opacity: 1,
        x: {
            format: 'dd MMM'
        },
    },
    markers: {
        size: 0,
        style: 'hollow',
    },
    annotations: {
        yaxis: [
            {
                y: props.targetAmount,
                borderColor: chartLabelColor,
                strokeDashArray: 2,
                label: {
                    borderColor: chartLabelColor,
                    borderWidth: 0,
                    borderRadius: 2,
                    offsetY: 7,
                    offsetX: -5,
                    style: {
                        color: '#fff',
                        background: chartExpectedAmountColor,
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 4,
                        }
                    },
                    text: 'Goal per day',
                }
            },
        ]
    }
});

const shouldRender = ref(false);
const chartReRenderPerformanceBoost = ref(false);
const shouldHideChart = ref(false)

const dataParsed = ref(null);

const series = reactive([
    {
        // color: chartBarColor,
        // zIndex: 1,
        data: dataParsed || [],
        name: 'Reps'
    }
])

onMounted(() => {
    runLoadDataIntoChart();
});

const runLoadDataIntoChart = async () => {
    // Yield back to the browser to allow for other tasks to run and allow UI to update
    await scheduler.yield();
    
    if (chartReRenderPerformanceBoost.value) {
        // Visbiility hide chart, this helps reduce DOM repaints
        shouldHideChart.value = true;
        
        // Yield back to the browser to allow for other tasks to run and allow UI to update
        await scheduler.yield();
    }


    // Populdate data
    dataParsed.value = props.data.map((item) => {
        return {
            x: item['Date'],
            y: item['y']
        }
    });

    series[0].data = dataParsed;

    if (chartReRenderPerformanceBoost.value) {
        // Yield back to the browser to allow for other tasks to run and allow UI to update
        await scheduler.yield();
        setTimeout(() => {
            shouldHideChart.value = false; // Reshow chart
        }, 450);
    }
}


watch(() => props.data, (newValue) => {
    runLoadDataIntoChart();
});
</script>

<template>
    <div class="repsOverTimeChart">
        
        <label><input type="checkbox" v-model="chartReRenderPerformanceBoost" />Hide chart durinng change (perf boost)</label><br>
        <label><input type="checkbox" v-model="shouldRender" /> Render Reps per Day <em>(causes lag)</em></label>
        <VueApexCharts v-show="shouldRender" :class="{ 'hiding-chart' :  shouldHideChart }" type="bar" :options="chartOptions" :series="series" height="450" />
    </div>
</template>

<style>
.hiding-chart {  display: none;}
</style>